import type { ReactNode } from 'react';

export const symbol_picture_in_picture_center: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm202-131h275q12.75 0 21.38-8.63Q647-368.25 647-381v-197q0-12.75-8.62-21.38Q629.75-608 617-608H342q-12.75 0-21.37 8.62Q312-590.75 312-578v197q0 12.75 8.63 21.37Q329.25-351 342-351ZM140-220v-520 520Z"
		/>
	</svg>
);
